/**
 * Helper sincrono per leggere l'override cross-tenant attivo.
 *
 * BE v1.8.3+: il cross-tenant si specifica via filter (`equals(tenant.id, X)`)
 * o relationship nel body, NON più via header HTTP. Il client JSON:API legge
 * questo helper e inietta automaticamente filter/relationship nelle list/POST.
 *
 * Storage: sessionStorage (l'override è volatile, scope sessione del browser).
 */
import { STORAGE_KEYS } from './constants';

export function getActiveTenantOverride(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEYS.activeTenantOverride);
  } catch {
    return null;
  }
}

/**
 * Risorse JSON:API che NON devono ricevere l'iniezione automatica di
 * filter[tenant.id] / data.relationships.tenant — perché non sono IHasTenant
 * o hanno semantica globale/user-scoped.
 *
 * Manutenzione: aggiungi un type qui se vedi 400 BadRequest sul filter
 * "Field tenant does not exist on resource X".
 */
export const TENANT_OVERRIDE_BLACKLIST = new Set<string>([
  // La risorsa Tenant stessa: ovviamente non si filtra per tenant.
  'tenants',
  // User-scoped (BE filtra per userId, non per tenant): IHasTenant ma irrilevante.
  'user-preferences',
]);

export function shouldApplyTenantOverride(type: string): boolean {
  return !TENANT_OVERRIDE_BLACKLIST.has(type);
}
